import $api from "../http";
import { AxiosResponse } from "axios";
import { ISite } from "../models/ISite";

export default class SiteService {
  static async fetchSiteContent(): Promise<AxiosResponse<ISite[]>> {
    return await $api.get<ISite[]>(`/site-settings`);
  }

  static async fetchUpdateOne(
    data: any,
    type: string
  ): Promise<AxiosResponse<ISite[]>> {
    return await $api.put<ISite[]>(`/site-settings/${type}`, data);
  }

  static async fetchReports(): Promise<AxiosResponse<any>> {
    return await $api.get<any>(`/reports`);
  }

  static async updateReport(data: FormData): Promise<AxiosResponse<any>> {
    return await $api.post<any>(`/reports`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static async deleteReport(id: any): Promise<AxiosResponse<any>> {
    return await $api.delete<any>(`/reports/remove/${id}`);
  }

  static async loadReport(id: string): Promise<AxiosResponse<any>> {
    return await $api.get<any>(`/reports/getOne/${id}`);
  }
}
